module.exports = __webpack_public_path__ + "media/images/welcome_leadership-af6955a5963a3b0540ebc6c75c0ff424.png";